import React from 'react';
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from "react-router-dom"
import Grid from '@material-ui/core/Grid'
import Avatar from '@material-ui/core/Avatar'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link';

import { logout } from '../actions/asyncMember'
import {
    cleanShippingOrderData,
} from 'actions/orders'

import logoIcon from 'static/images/icons/logo.png'
import bellIcon from 'static/images/icons/bell.svg'
import deliveryIcon from 'static/images/icons/delivery.svg'
import avatarIcon from 'static/images/avatar.svg'

const Header = props => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { inboundOrderList, shippingCart, memberInfo } = props
    const inboundOrderTotal = inboundOrderList.getIn(['pagination', 'totalCount'])
    const shippingCartTotal = shippingCart.getIn(['pagination', 'totalCount'])

    function handleClick(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleLogout() {
        props.logout()
        handleClose()
    }

    return (
        <AppBar color="inherit">
            <Toolbar disableGutters>
                <Grid container justify="space-between" style={{ padding: '10px 100px' }}>
                    <img src={logoIcon} style={{ height: '40px' }} alt="" />
                    <Grid container item xs={8} justify="flex-end" alignItems="center">
                        <Link
                            to="/how-to-use"
                            style={{ marginRight: '40px' }}
                            component={RouterLink}
                            underline="none"
                        >
                            <Typography color="textPrimary">{t('store_wine')}</Typography>
                        </Link>
                        <Link
                            to="/member/wines"
                            style={{ marginRight: '40px' }}
                            component={RouterLink}
                            underline="none"
                        >
                            <Typography color="textPrimary">{t('storage_winelist')}</Typography>
                        </Link>
                        <Link
                            to="/member/order"
                            style={{ marginRight: '40px' }}
                            component={RouterLink}
                            underline="none"
                        >
                            <Typography color="textPrimary">{t('order_list')}</Typography>
                        </Link>
                        <Link
                            to="/member/coupon"
                            style={{ marginRight: '40px' }}
                            component={RouterLink}
                            underline="none"
                        >
                            <Typography color="textPrimary">{t('coupon')}</Typography>
                        </Link>
                        <Avatar
                            src={memberInfo.imageUrl || avatarIcon}
                            style={{ width: '36px', height: '36px', marginRight: '20px', cursor: 'pointer' }}
                            onClick={handleClick}
                        />
                        <Link
                            to="/member/inbound"
                            component={RouterLink}
                            underline="none"
                            style={{ marginRight: '20px' }}
                            className="nav-icon"
                        >
                            <img src={bellIcon} style={{ width: '18px' }} alt="notification_important" />
                            {!!inboundOrderTotal && 
                                <div className="red-hint">{inboundOrderTotal}</div>
                            }
                        </Link>
                        <Link
                            to="/member/shippingcart"
                            component={RouterLink}
                            underline="none"
                            className="nav-icon"
                            onClick={props.cleanShippingOrderData}
                        >
                            <img src={deliveryIcon} style={{ width: '25px' }} alt="shopping_cart" />
                            {!!shippingCartTotal &&
                                <div className="red-hint"><div className="wh-point"/></div>
                            }
                        </Link>
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <Link
                                to="/member/setting/info"
                                component={RouterLink}
                                underline="none"
                                onClick={handleClose}
                            >
                                <MenuItem>
                                    <Typography color="textPrimary">{t('setting_edit')}</Typography>
                                </MenuItem>
                            </Link>
                            <Link
                                to="/member/setting/card"
                                component={RouterLink}
                                underline="none"
                                onClick={handleClose}
                            >
                                <MenuItem>
                                    <Typography color="textPrimary">{t('credit_card_edit')}</Typography>
                                </MenuItem>
                            </Link>

                            <MenuItem onClick={handleLogout}>
                                <Typography color="textPrimary">{t('logout')}</Typography>
                            </MenuItem>
                        </Menu>
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    )
}

export default connect(
    state => ({
        shippingCart: state.orders.shippingCart,
        inboundOrderList: state.orders.inboundOrderList,
        memberInfo: state.member.member
    }),
    { logout, cleanShippingOrderData }
)(Header)